module.exports = __webpack_public_path__ + "img/11.fe96faf3.jpg";